import React from 'react';
import { useNavigate } from 'react-router-dom';
import './success.css'; // Optional: for styling
import Header from '../HeaderComponent/Header';
import Footer from '../FooterComponent/Footer';
import { useSelector } from 'react-redux';
import { getBusinessUnit } from '../../store/APISlice';

const Success: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/dashboard'); // Navigate to the home page
  };

  const selectedBu = useSelector(getBusinessUnit);
  const description = `PTS - Order Entry Request - ${selectedBu}`

  return (<>
    <div style={{ flex: '0 1 auto' }}>
      <Header headDescription={description} />
    </div>
    <div className="mainDiv">
      <div className='childDiv'>
        <div className="success-container">
          <div className="icon-container">
            <div className="check-icon">✔️</div>
          </div>
          <h1>Thank you</h1>
          <p>Your Request has been submitted successfully</p>
          <button className="go-home-button" onClick={handleGoHome}>Go to Home</button>
        </div>
      </div>
    </div>
    <div style={{ flex: '0 1 auto', position: 'fixed', bottom: 0, width: '100%', backgroundColor: 'white', overflow: 'hidden' }}>
      <Footer />
    </div>
  </>
  );
};

export default Success;